import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export type AlertTypeOption = {
    id: string
    name: string
}

export const useAlertTypeOptions = (): AlertTypeOption[] => {
    const { t } = useTranslation()

    return useMemo(
        () => [
            { id: 'shipment_activation', name: t('Shipment Activated') },
            {
                id: 'shipment_departure',
                name: t('Shipment Departed from Origin'),
            },
            { id: 'shipment_waypoint', name: t('Waypoint Alert') },
            {
                id: 'shipment_arrival',
                name: t('Shipment Arrived at Destination'),
            },
            { id: 'shipment_completion', name: t('Shipment Completed') },
            { id: 'shipment', name: t('Shipment Alert') },
            { id: 'temperature', name: t('Temperature Out of Range') },
            { id: 'humidity', name: t('Humidity Out of Range') },
            { id: 'airPressure', name: t('Air Pressure Out of Range') },
            {
                id: 'accessPointRssi',
                name: t('Signal Weak (Access Point Rssi)'),
            },
            { id: 'towerRssi', name: t('Signal Weak (Tower Rssi)') },
            { id: 'batteryPercent', name: t('Battery Low') },
            { id: 'light', name: t('Door Open') },
            { id: 'vibration', name: t('Shock Detected') },
            { id: 'unknown', name: t('Unknown Alert') },
            {
                id: 'shipment_waypoint_dwell_time',
                name: t('Shipment Waypoint Dwell Time'),
            },
            { id: 'maritime_delay', name: t('Maritime Delay') },
        ],
        [t],
    )
}
